module.exports = __webpack_public_path__ + "static/mermaid-commission-8d075cfdd29c5cce450aaab42eeec79d.jpg";